<template>
	<div class="home-wrap">

		<el-container>
			<el-header>
				<div class="left">
					<img src="../assets/logo.png" />
					<p>后台管理系统</p>
				</div>
				<div class="right">
					<el-button @click="logout">退出</el-button>
				</div>
			</el-header>
			<el-container>
				<el-aside width="200px">

					<el-menu default-active="2" class="el-menu-vertical-demo" background-color="#2361AC"
					 text-color="#fff" active-text-color="#ffd04b" router>
						<!-- <el-submenu index="1">
							<template slot="title">
								<i class="el-icon-s-order"></i>
								<span>活动&资讯</span>
							</template>
						
							<el-menu-item index="/huodonglist">
								<i class="el-icon-menu"></i>
								<span slot="title">活动</span>
							</el-menu-item>
							<el-menu-item index="/zixunlist">
								<i class="el-icon-menu"></i>
								<span slot="title">资讯</span>
							</el-menu-item>
							
						</el-submenu> -->
						
						<el-submenu index="2">
							<template slot="title">
								<i class="el-icon-s-home"></i>
								<span>九航集团首页</span>
							</template>
						
							<!-- <el-menu-item>
								<i class="el-icon-menu"></i>
								<span slot="title">修改1</span>
							</el-menu-item> -->
							<el-menu-item index="/shoye">
								<i class="el-icon-menu"></i>
								<span slot="title">首页设置</span>
							</el-menu-item>
						</el-submenu>
						
						<el-submenu index="3">
							<template slot="title">
								<i class="el-icon-picture-outline-round"></i>
								<span>集团简介</span>
							</template>
						
							<el-menu-item index="/jianjie">
								<i class="el-icon-menu"></i>
								<span slot="title">集团简介设置</span>
							</el-menu-item>
						</el-submenu>
						<el-submenu index="4">
							<template slot="title">
								<i class="el-icon-s-cooperation"></i>
								<span>旗下品牌</span>
							</template>
							<el-menu-item index="/pinpai">
								<i class="el-icon-menu"></i>
								<span slot="title">旗下品牌设置</span>
							</el-menu-item>
						</el-submenu>
						<el-submenu index="5">
							<template slot="title">
								<i class="el-icon-s-order"></i>
								<span>新闻资讯</span>
							</template>
							
							<el-menu-item index="/huodonglist">
								<i class="el-icon-menu"></i>
								<span slot="title">活动</span>
							</el-menu-item>
							<el-menu-item index="/zixunlist">
								<i class="el-icon-menu"></i>
								<span slot="title">资讯</span>
							</el-menu-item>
						</el-submenu>
						<el-submenu index="6">
							<template slot="title">
								<i class="el-icon-s-check"></i>
								<span>加入我们</span>
							</template>
							
							<el-menu-item index="/lianxiwomen">
								<i class="el-icon-menu"></i>
								<span slot="title">加入我们设置</span>
							</el-menu-item>
						</el-submenu>
					</el-menu>

				</el-aside>
				<el-main>
					<router-view></router-view>
				</el-main>
			</el-container>
		</el-container>

	</div>
</template>

<script>
	// @ is an alias to /src
	/* import HelloWorld from '@/components/HelloWorld.vue' */

	export default {
		name: 'Home',
		components: {
			/* HelloWorld */
		},
		methods:{
			
				logout () {
				  // 清空token
				  window.sessionStorage.clear()
				  this.$router.push('/login')
				}
			
		}
	}
</script>

<style lang="less" scoped>
	.home-wrap {
		height: 100%;
	}

	.el-container {
		height: 100%;
	}

	.el-header {
		background-color: #2361AC;
		color: #fff;
		display: flex;
		align-items: center;
		justify-content: space-between;
		
		.left{
			display: flex;
			align-items: center;
			
			 img{
				height: 40px;
				margin-right: 20px;
			 }
		}
	}

	.el-aside {
		background-color: #2361AC;
		height: 100%;
	}

	.el-main {
		background-color: #eee;
		height: 100%;
	}
	.el-submenu__title i{
		color: #fff;
	}
	.el-menu {
	  border: none;
	}
</style>
